// angular
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../../core/core.service';

// others
import { AppService } from '../../../app.service';
import { AuthService } from '../../../core/auth.service';
import { BannersService } from '../banners.service';
import { Router } from '@angular/router';
import { BannersComponent } from '../banners.component';
import { KlenicoMeService } from '../../me.service';

@Component({
    selector: 'test-user-card',
    templateUrl: './test-user-card.component.html',
    styleUrls: ['./test-user-card.component.scss']
})

export class TestUserCardComponent extends BannersComponent implements OnInit {
    data: any;
    submitted: boolean;
    checked: boolean = false;
    storyBlock = 'test-user';
    replaceText = {};

    @Input() callApi = true;
    @Input() blockData = false;
    @Input() profile: any;
    @Input() slug: string;
    @Input() notificationType = '';
    @Output() updateUI = new EventEmitter();
    @ViewChild('formDirective') private formDirective: NgForm;

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public translate: TranslateService,
        public coreService: CoreService,
        public router: Router,
        public profileService: BannersService,
        public authService: AuthService,
        public meService: KlenicoMeService,
        public bannerService: BannersService
    ) {
        super(appService, translate, coreService, router, profileService, authService, meService);
    }

    ngOnInit() {
        // this.url = this.url + '/' + this.storyBlock;
        if (this.callApi) {
            this.url = this.url + '/' + this.slug;
            this.getContent();
            this.translate.onLangChange.subscribe(value => {
                this.getContent();
            });
        } else {
            this.data = this.blockData['content'];
        }
    }

    ngAfterViewInit() {
        this.replaceText = {
            'nextEvaluationDate:date' : this.meService.nextCreateSr
        };

        if (this.data.closeTriggers && this.data.closeTriggers.length > 0) {
            this.checkCloseTrigger();
        }
    }

    submit(value, valid, form) {
        this.editting = false;
        return super.submit(this.form.value, this.form.valid);
    }

    /**
     * @param params
     */
    openFormModal(params: Object, navigate = false) {
        this.initForm(params, navigate);
        this.editting = true;
    }

    checkCloseTrigger() {
        this.meService.notifications.forEach(noti => {
            if(this.data.closeTriggers.indexOf(noti.type) >= 0) {
                this.closeBanner();
            }
        });
    }

    closeBanner() {
        this.bannerService.updateNotificationProcessed({
            showOnce : this.data.showOnce,
            processed: true,
            type: this.data.trigger
        }).subscribe(res => {
            this.meService.TRIGGERS[this.data.trigger] = 0;
        })
    }
}
